<div class="d-flex flex-column main-menu">
        <mat-list-item class="col-121">
            <div class="mat-list-item d-flex align-items-center frame">
                <img [src]="cvaUI_url + '/assets/icons/user-profile.svg'" alt="Profile">
                <label class="subheading-label" for="profile">{{practitionerService.loggedInPractitioner?.firstName || ""}} {{practitionerService.loggedInPractitioner?.lastName || ""}}</label>
            </div>
        </mat-list-item>
        <mat-list-item class="col-121" (click)="changePassword()" onKeyDown="doNothing();" tabindex="0">
            <div class="mat-list-item d-flex align-items-center frame">
                <img [src]="cvaUI_url + '/assets/icons/change-password.svg'" alt="Change Password">
                <label class="subheading-label" for="historicalData">Change Password</label>
            </div>
        </mat-list-item>
        <mat-list-item class="col-121" (click)="logout()" onKeyDown="doNothing();" tabindex="0">
            <div class="mat-list-item d-flex align-items-center frame" >
                <img [src]="cvaUI_url + '/assets/icons/logout.svg'" alt="Logout">
                <label class="subheading-label" for="historicalData">Logout</label>
            </div>
        </mat-list-item>
</div>
